
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import React, { useState,useEffect,useRef } from "react";
import axios from 'axios';
import {useParams } from 'react-router-dom';
import Plot from 'react-plotly.js';
import styled from "styled-components";
import Slider from '@mui/material/Slider';
import AirportCarousel from '../../components/AirportCarousel';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import {PlotSectionDiv, EpochDataBlock} from '../../components/DisplayComponents';
import {PlotLoadingOverlay} from '../../components/PlotLoadingOverlay';
import Checkbox from '@mui/material/Checkbox';
import { PawPrint, Youtube } from 'lucide-react';
import { FormControlLabel, Typography } from '@mui/material';
import { Fa500Px } from 'react-icons/fa';

const DEG_TO_NM   = 60.0405
const NM_TO_DEG   = 1/DEG_TO_NM
// const DetailedSummaryOverlayDivStyle = styled.div`
  // position: fixed;
  // text-align:center;
  // justify:center;
  // display:block;
  // flex: none;
  // top:0;
  // bottom:0;
  // left:0;
  // right:0;
  // padding-top:10%;
  // width: 100%;
  // height: 100%;
  // background-color: rgba(0,0,0,0.5); 
  // z-index: 17; 
  // cursor: pointer;
// `;

// const OverlaychartPlotDivStyle = styled.div`
  // display:block;
  // flex:none;
  // justify-content: center;
  // align-items: center;
// `;

// const DetailedSummaryOverlayDiv = ()=>{
        // return(
            // <div style={{position:"fixed",zIndex:15}} >
            // <DetailedSummaryOverlayDivStyle>
                // <OverlaychartPlotDivStyle id="overlayPlot" onClick={handleOverlayClick}>
                // <Plot  data={[{
                    // x: metroplexEncroachmentDataAll.epochString,
                    // y: metroplexEncroachmentDataAll.encrDur.Total,
                    // type: 'scatter',
                    // mode: 'lines+markers',
                    // marker: {color: 'red'},
                  // },
                // ]}
                // id="chartPlotDiv"
                // layout={ {title: 'Detailed Summary',width:600,height:400} }
              // />
              // </OverlaychartPlotDivStyle>
            // </DetailedSummaryOverlayDivStyle>
            // </div>
            // );
    // };

const Layout = styled.div`
    display:flex;
    flex:1 1;
    width:100vh;
    justify-content:flex-start;
    flex-wrap:wrap;
    gap: 10px 10px;
    max-height: calc(100vh - 150px);
`;

  
const TitleDiv = styled.div`
    min-width:85vw;
`;

// const colorPalette = ['#2E91E5','#E15F99','#1CA71C','#FB0D0D','#DA16FF','#222A2A','#B68100','#750D86','#EB663B','#511CFB',
// 					'#FB0D0D','#DA16FF','#222A2A']

const ALPHA = 0.6;
const colorPalette = ['rgba(46, 145, 229,'+ALPHA+')','rgba(225, 95, 153,'+ALPHA+')','rgba(28, 167, 28,'+ALPHA+')','rgba(251, 13, 13,'+ALPHA+')']

const zoomPlusEvent = new KeyboardEvent('keydown', {
  key: '+',           // The key value ('+' for plus)
  code: 'Equal',      // The physical key code (often 'Equal' for '+')
  keyCode: 187,       // The keyCode for '=' which also serves as '+'
  which: 187,         // The which value, same as keyCode
  ctrlKey: true,      // Indicates that Ctrl is pressed
  shiftKey: true,     // Shift is usually needed for the '+' sign
  bubbles: true,      // If the event should bubble up through the DOM
  cancelable: true    // If the event is cancelable
});

const zoomMinusEvent = new KeyboardEvent('keydown', {
  key: '-',           // The key value ('+' for plus)
  code: 'Equal',      // The physical key code (often 'Equal' for '+')
  keyCode: 187,       // The keyCode for '=' which also serves as '+'
  which: 187,         // The which value, same as keyCode
  ctrlKey: true,      // Indicates that Ctrl is pressed
  shiftKey: true,     // Shift is usually needed for the '+' sign
  bubbles: true,      // If the event should bubble up through the DOM
  cancelable: true    // If the event is cancelable
});
// <TitleDiv>
            // <h1 style={{marginLeft:'10px'}}>{airport+', '+airportData['city']+' - Mashup Dashboard'}</h1>
        // </TitleDiv>
const sliderMarks = [
  {
    value: 0,
    label: '5 min',
  },
  {
    value: 1,
    label: '1 hour',
  },
  {
    value: 2,
    label: '24 hours',
  },
];

const locationMapPeriods= ['5min','1hr','24hr']
function correctAirportFormat(airportObj){
  return(airportObj['airport'].toUpperCase())
}

const VectoringCounts = ({setTitle,pageTitle,metricLookBackHorizonDays,backendApiPrefix}) => {
    
    const airport = correctAirportFormat(useParams())
    const AIRPORT_MARKER_TEMPLATE = {type: "scattermapbox",
                                      lat: [],
                                      lon: [],
                                      text:[],
                                      textfont:{size:16,color:'black'},
                                      textposition:'middle left',
                                      marker: {symbol:'marker',color: "black", size: 10,allowoverlap:true},
                                      hoverinfo:'skip',
                                      name:'',
                                      mode:'markers+text',
                                      hovertemplate:'<extra></extra>',
                                      showlegend:false}

    useEffect(() => {
        setTitle(pageTitle=>'Workload Proxy Metrics - '+airport)
    },[airport]);
    const [isChartLoading,setIsChartLoading] = useState(true)
    const [isMapLoading,setIsMapLoading] = useState(true)
    const [lastUpdatedTime,setLastUpdatedTime] = useState(new Date())
    const [loadingDataFlag,setLoadingDataFlag] = useState(true)
    const [queryIterTime,setQueryIterTime] = useState(new Date())
    const [metricStartTime,setMetricStartTime] = useState(new Date(new Date().getTime() - 2*24 * 60 * 60 * 1000))
    const [airportMapTraces,setAirportMapTraces] = useState([AIRPORT_MARKER_TEMPLATE])
    // const [plotConfig,setPlotConfig] = useState({modeBarButtonsToRemove:['toImage','zoom2d',
    //                                         'toggleSpikelines','select2d',
    //                                         'zoomIn2d','zoomOut2d','lasso2d'],
    //                                          displaylogo:false,responsive:true})
  
    const [plotConfig,setPlotConfig] = useState({modeBarButtonsToRemove:['toImage','zoom2d',
                                            'toggleSpikelines','select2d',
                                            'zoomIn2d','zoomOut2d','lasso2d',
                                            'pan2d','autoScale2d', 'resetScale2d','hoverClosestCartesian',
                                            'hoverCompareCartesian','zoom3d','pan3d', 'resetCameraDefault3d',
                                            'resetCameraLastSave3d', 'hoverClosest3d', 'orbitRotation', 
                                            'tableRotation', 'zoomInGeo', 'zoomOutGeo', 'resetGeo', 
                                            'hoverClosestGeo', 'toImage', 'sendDataToCloud', 'hoverClosestGl2d',
                                            'hoverClosestPie', 'toggleHover', 'resetViews', 'toggleSpikelines', 'resetViewMapbox'],
                                              displaylogo:false,responsive:true})
    const [plotStyle,setPlotStyle] = useState({width:'100%',height:'100%'})
    const [revision,setRevision] = useState(0)
    const [airportData, setAirportData] = useState({'location':[],'city':''}); 
    const [metroplexData,setMetroplexData] = useState({})
    const [vectoringCountsDataAll, setVectoringCountsDataAll] = useState({Epoch:[],NumArrAC:[],
                                                                          VectorCounts:{Heading:[],Speed:[],Altitude:[]},
                                                                          NormalizedVectorCounts:{Heading:[],Speed:[],Altitude:[]}}); 
    const timeMap = {'5min':[],'1hr':[],'24hr':[]}
    
    const [normalizationFlag,setNormalizationFlag] = useState(false)
    const [selectedEpoch,setSelectedEpoch] = useState('')
    const [highlightYMarker,setHighlightYMarker] = useState({'index':1,'index2':1,'index3':1,'index4':1})
    const [latestEpochFlag,setLatestEpochFlag] = useState(true)
    const [anomalousAcList,setAnomalousAcList] = useState([])
    const [selectedAc,setSelectedAc] = useState('')
    const [vectoringAircraftData,setVectoringAircraftData] = useState({Heading:{},Speed:{},Altitude:{}})
    const [heatMapData,setHeatMapData] = useState({Heading:{'5min':{lat:[],lon:[],alt:[]},
                                                            '1hr':{lat:[],lon:[],alt:[]},
                                                            '24hr':{lat:[],lon:[],alt:[]}},
                                                  Speed:{'5min':{lat:[],lon:[],alt:[]},
                                                          '1hr':{lat:[],lon:[],alt:[]},
                                                          '24hr':{lat:[],lon:[],alt:[]}},
                                                  Altitude:{'5min':{lat:[],lon:[],alt:[]},
                                                             '1hr':{lat:[],lon:[],alt:[]},
                                                            '24hr':{lat:[],lon:[],alt:[]}}})
    const [displayClustersFlag,setDisplayClustersFlag] = useState(false)
    const [onlyClustersFlag,setOnlyClustersFlag] = useState(false)
    const [heatMapClustersData,setHeatMapClustersData] = useState({Heading:{'5min':{lat:[],lon:[],alt:[]},
                                                              '1hr':{lat:[],lon:[],alt:[]},
                                                              '24hr':{lat:[],lon:[],alt:[]}},
                                                    Speed:{'5min':{lat:[],lon:[],alt:[]},
                                                            '1hr':{lat:[],lon:[],alt:[]},
                                                            '24hr':{lat:[],lon:[],alt:[]}},
                                                    Altitude:{'5min':{lat:[],lon:[],alt:[]},
                                                               '1hr':{lat:[],lon:[],alt:[]},
                                                              '24hr':{lat:[],lon:[],alt:[]}}})

    const [plotMapLayout, setPlotMapLayout] = useState({
                                                        mapbox: 
                                                        { style: "light", 
                                                        zoom:7,
                                                        accesstoken:"pk.eyJ1IjoidmFydW5zdWRhcnNhbmFuIiwiYSI6ImNscmpiazJ0cDAxb2IyaXFiaWQxY2hobHgifQ.oFJXYhV7inwFB3TeBwa86g",
                                                        
                                                        },
                                                        margin:{l:10,t:10,r:12,b:10},
                                                        showlegend:false,plot_bgcolor:'rgba(220,232,247,0.4)'
                                                        },
                                                        );
    const [plotChartLayout, setPlotChartLayout] = useState({grid:{rows:4,columns:1,xside:'bottom plot',ygap:0.2},
                                                                xaxis:{anchor:'y',
                                                                        rangeselector:{
                                                                          x:0,y:1.01,
                                                                          xanchor:'left',
                                                                        buttons:[{count:1,label:'1hr',step:'hour',stepmode:'backward'},
                                                                                 {count:12,label:'12hrs',step:'hour',stepmode:'backward'},
                                                                                 {count:1,label:'1d',step:'day',stepmode:'backward'},
                                                                                 {step:'all'}]},
                                                                        type:'date',
                                                                        zeroline:false},
                                                                sharedx:true,
                                                                hovermode:'x unified',
                                                                showlegend:false,
                                                                height:700,
                                                                yaxis:{anchor:'x',zeroline:false,'title':'Num. Arriving AC'},
                                                                yaxis2:{anchor:'x',zeroline:false,'title':'Heading Change<br>Counts '},
                                                                yaxis3:{anchor:'x2',zeroline:false,'title':'Speed Change<br>Counts '},
                                                                yaxis4:{anchor:'x3',zeroline:false,'title':'Altitude Change<br>Counts '},
                                                                margin:{t:54,r:10,b:10},
                                                                plot_bgcolor:'rgba(220,232,247,0.4)'}
                                                                );
    
    const [leftDivHeight, setLeftDivHeight] = useState(null);
    const [leftDivWidth, setLeftDivWidth] = useState(null);
    
    const [rightDivHeight, setRightDivHeight] = useState(null);
    const [rightDivWidth, setRightDivWidth] = useState(null);
    
    const [revKey, setRevKey] = useState(0);
    // useEffect(() => {
    //   const interval = setInterval(() => {
    //     setLastUpdatedTime(new Date())
    //     getLatestMetricData()
    //   }, 10000);
    //   return () => clearInterval(interval);
    // }, [airportData]);

    const heatMapMetrics = ['Heading','Speed','Altitude']
    const [heatMapMetricChecked,setHeatMapMetricChecked] = useState({'Heading':true,'Speed':false,'Altitude':false})
    const [heatMapMetricLabel,setHeatMapMetricLabel] = useState({Heading:'Heading Changes',Speed:'Speed Changes',Altitude:'Altitude Changes'})
    const [anomalyTypeLabels,setAnomalyTypeLabels] = useState({Altitude:'Ascending Aircraft',Speed:'Accelerating Aircraft',Heading:'Heading Changes'})
    const [heatMapTimePeriod,setHeatMapTimePeriod] = useState(locationMapPeriods[0])

    const [anomalousAircraftMetricChecked,setAnomalousAircraftMetricChecked] = useState({'Heading':true,'Speed':false,'Altitude':false})

    const [mapPlotTraces, setMapPlotTraces] = useState([])
    useEffect(() =>{
      setTimeout(()=>{
      setPlotChartLayout({...plotChartLayout,
                          width:0.98*leftDivWidth
                        });
      
      // setPlotMapLayout({...plotMapLayout,
                       // width:0.98*rightDivWidth,
                       // });
                       
      setPlotMapLayout({...plotMapLayout,
                           width:0.98*rightDivWidth,
                           mapbox: {...plotMapLayout.mapbox,
                                                center:{
                                                lat:airportData['location'][0],
                                                lon:airportData['location'][1]
                                                },
                                                bounds:{'north':airportData['location'][0]+200*NM_TO_DEG,
                                                     'east':airportData['location'][1]+200*NM_TO_DEG,
                                                    'south':airportData['location'][0]-200*NM_TO_DEG,
                                                     'west':airportData['location'][1]-200*NM_TO_DEG},
                                    },
                            zoom:7});
                                    
      var mapTraces = []
      console.log(metroplexData)
      for(var arpt of Object.keys(metroplexData)){
        var trace = {...AIRPORT_MARKER_TEMPLATE,
          lat:[metroplexData[arpt]['location'][0]],
          lon:[metroplexData[arpt]['location'][1]],
          text:[arpt.slice(1)],
          name:arpt,
          textfont:{size:14,color:arpt.slice(1)===airport?'black':'gray'},
          hovertemplate:'<extra></extra>'+arpt
        }
        mapTraces.push(trace)
      }
      setAirportMapTraces(mapTraces)
                       
      },20)
    },[leftDivWidth,rightDivWidth,airport,airportData,metroplexData]);
    
    function resetMetricStates(){
      setQueryIterTime(new Date())
      setMetricStartTime(new Date(new Date().getTime() - 2*24*60 * 60 * 1000))
      setVectoringCountsDataAll({Epoch:[],VectorCounts:{Heading:[],Speed:[],Altitude:[]}})
  };
  function getYRanges(){
    var yRanges = {yaxis:{...plotChartLayout.yaxis,
                   range:[0,1.2*Math.max(...vectoringCountsDataAll.NumArrAC)]
                  },
                  yaxis2:{...plotChartLayout.yaxis2,
                              range:[0,1.2*Math.max(...vectoringCountsDataAll.VectorCounts.Heading)],
                  },
                  yaxis3:{...plotChartLayout.yaxis3,
                    range:[0,1.2*Math.max(...vectoringCountsDataAll.VectorCounts.Speed)],
                  },
                  yaxis4:{...plotChartLayout.yaxis4,
                    range:[0,1.2*Math.max(...vectoringCountsDataAll.VectorCounts.Altitude)],
                  }}
    return yRanges
  };
  useEffect(() =>{
    var yRanges = getYRanges()
    setPlotChartLayout({...plotChartLayout,...yRanges})
},[])

    useEffect(() => {
        // resetMetricStates()
        axios.post(backendApiPrefix+'/api/get-airport-data/',{airport:airport})
            .then(response => {
                var jsonData = response.data.message
                setAirportData(jsonData)
            })
            .catch(error => {
                console.log(error);
            });
    },[airport]);

    useEffect(() => {
      // resetMetricStates()
      axios.post(backendApiPrefix+'/api/get-metroplex-data/',{airport:airport})
          .then(response => {
              var jsonData = response.data.message
              setMetroplexData(jsonData)
          })
          .catch(error => {
              console.log(error);
          });
  },[airport]);

    function updateHeatMapData(epoch){
      console.log(epoch)

      var vectorLocations_api = backendApiPrefix+'/api/get-vectoring-locations-data/'

      axios.post(vectorLocations_api,{airport:airport,epoch:epoch})
        .then(response =>{
            var jsonData = response.data.message
            setHeatMapData({'Heading':{'5min':jsonData['locData']['VectorLocations.Heading_5min'],
                                                 '1hr':jsonData['locData']['VectorLocations.Heading_1hr'],
                                                '24hr':jsonData['locData']['VectorLocations.Heading_24hr']},
                                     'Speed':{'5min':jsonData['locData']['VectorLocations.Speed_5min'],
                                                 '1hr':jsonData['locData']['VectorLocations.Speed_1hr'],
                                                '24hr':jsonData['locData']['VectorLocations.Speed_24hr']},
                                     'Altitude':{'5min':jsonData['locData']['VectorLocations.Altitude_5min'],
                                                 '1hr':jsonData['locData']['VectorLocations.Altitude_1hr'],
                                                '24hr':jsonData['locData']['VectorLocations.Altitude_24hr']}})
            

            setHeatMapClustersData({'Heading':{'5min':jsonData['locData']['ClusterCenters.Heading_5min'],
                                              '1hr':jsonData['locData']['ClusterCenters.Heading_1hr'],
                                            '24hr':jsonData['locData']['ClusterCenters.Heading_24hr']},
                                  'Speed':{'5min':jsonData['locData']['ClusterCenters.Speed_5min'],
                                              '1hr':jsonData['locData']['ClusterCenters.Speed_1hr'],
                                            '24hr':jsonData['locData']['ClusterCenters.Speed_24hr']},
                                  'Altitude':{'5min':jsonData['locData']['ClusterCenters.Altitude_5min'],
                                              '1hr':jsonData['locData']['ClusterCenters.Altitude_1hr'],
                                            '24hr':jsonData['locData']['ClusterCenters.Altitude_24hr']}})
            setIsMapLoading(false)

        }).catch(error => {
          console.log(error);
          setIsMapLoading(false)
        });

    };

    function updateAnomalousAircraftData(epoch){
      var anomalousAircraft_api = backendApiPrefix+'/api/get-vectoring-counts-aircraft-data/'

      axios.post(anomalousAircraft_api,{airport:airport,epoch:epoch})
        .then(response =>{
            var jsonData = response.data.message
            console.log("jsonData",jsonData)
            var acData = {'Heading':jsonData['ManyHeadingChanges'],
                           'Speed':jsonData['AcceleratingAircraft'],'Altitude':jsonData['AscendingAircraft']}
            
            var acList = []
            console.log("acData",acData)
            for(var metKey of Object.keys(anomalousAircraftMetricChecked)){
              console.log(metKey,Object.keys(acData[metKey]))
              console.log(anomalousAircraftMetricChecked)
              if(anomalousAircraftMetricChecked[metKey]){
                acList.push(...Object.keys(acData[metKey]))
              }
            }
            setVectoringAircraftData(acData)
            setAnomalousAcList(acList)
            if(acList.length > 0){
              setSelectedAc(acList[0])
            }
        }).catch(error => {
          console.log(error);
        });
      
    };

    useEffect(() => {
      var QUERY_CHUNK_HOURS = 4;
        if(queryIterTime.getTime() >= metricStartTime.getTime()){
            var queryEndTime = queryIterTime
            var shiftedQueryIterTime = new Date(queryIterTime.getTime() - QUERY_CHUNK_HOURS* 60*60*1000)
            var queryEndTimeComps = queryEndTime.toUTCString().split(/-| |:/)
            var queryEndTimeForAPIQuery = queryEndTimeComps[3]+queryEndTimeComps[2]+queryEndTimeComps[1]+queryEndTimeComps[4]+queryEndTimeComps[5]

            var queryStartTimeComps = shiftedQueryIterTime.toUTCString().split(/-| |:/)
            var queryStartTimeForAPIQuery = queryStartTimeComps[3]+queryStartTimeComps[2]+queryStartTimeComps[1]+queryStartTimeComps[4]+queryStartTimeComps[5]
            axios.post(backendApiPrefix+'/api/get-vectoring-counts-data/',{airport:airport,from:queryStartTimeForAPIQuery,to:queryEndTimeForAPIQuery})
                  .then(response => {
                    QUERY_CHUNK_HOURS += 1;
                    console.log("QUERYING")
                    var jsonData = response.data.message
                    setQueryIterTime(shiftedQueryIterTime)
                    setVectoringCountsDataAll({...vectoringCountsDataAll,
                                                Epoch:[...jsonData.countData.Epoch,...vectoringCountsDataAll.Epoch],
                                                NumArrAC:[...jsonData.countData['NumArrAC.Total'],...vectoringCountsDataAll.NumArrAC],
                                                VectorCounts:{
                                                  Heading:[...jsonData.countData['VectorCounts.Heading'],...vectoringCountsDataAll.VectorCounts.Heading],
                                                  Speed:[...jsonData.countData['VectorCounts.Speed'],...vectoringCountsDataAll.VectorCounts.Speed],
                                                  Altitude:[...jsonData.countData['VectorCounts.Altitude'],...vectoringCountsDataAll.VectorCounts.Altitude]
                                                },
                                                NormalizedVectorCounts:{
                                                  Heading:[...jsonData.countData['VectorCounts.Heading_perNumAC'],...vectoringCountsDataAll.NormalizedVectorCounts.Heading],
                                                  Speed:[...jsonData.countData['VectorCounts.Speed_perNumAC'],...vectoringCountsDataAll.NormalizedVectorCounts.Speed],
                                                  Altitude:[...jsonData.countData['VectorCounts.Altitude_perNumAC'],...vectoringCountsDataAll.NormalizedVectorCounts.Altitude]
                                                }
                                              })             
                    if(latestEpochFlag&&selectedEpoch===''){
                      if(vectoringCountsDataAll.Epoch.length>0){
                          setSelectedEpoch(vectoringCountsDataAll.Epoch[vectoringCountsDataAll.Epoch.length-1])
                          updateHeatMapData(vectoringCountsDataAll.Epoch[vectoringCountsDataAll.Epoch.length-1])
                          updateAnomalousAircraftData(vectoringCountsDataAll.Epoch[vectoringCountsDataAll.Epoch.length-1])
                      }else{
                          setSelectedEpoch(jsonData.countData.Epoch[jsonData.countData.Epoch.length-1])
                          updateHeatMapData(jsonData.countData.Epoch[jsonData.countData.Epoch.length-1])
                          updateAnomalousAircraftData(jsonData.countData.Epoch[jsonData.countData.Epoch.length-1])
                      }
                      
                      var yRangeMax; var y2RangeMax;var y3RangeMax; var y4RangeMax;
                      var xRangeMin; var xRangeMax;
                      if(vectoringCountsDataAll.Epoch.length>0){
                          yRangeMax = 1.2*Math.max(...[...vectoringCountsDataAll.NumArrAC,...jsonData.countData['NumArrAC.Total']])
                          y2RangeMax = 1.2*Math.max(...[...vectoringCountsDataAll.VectorCounts.Heading,...jsonData.countData['VectorCounts.Heading']])
                          y3RangeMax = 1.2*Math.max(...[...vectoringCountsDataAll.VectorCounts.Speed,...jsonData.countData['VectorCounts.Speed']])
                          y4RangeMax = 1.2*Math.max(...[...vectoringCountsDataAll.VectorCounts.Altitude,...jsonData.countData['VectorCounts.Altitude']])
                      }else{
                          yRangeMax = 1.2*Math.max(...jsonData.countData['NumArrAC.Total'])
                          y2RangeMax = 1.2*Math.max(...jsonData.countData['VectorCounts.Heading'])
                          y3RangeMax = 1.2*Math.max(...jsonData.countData['VectorCounts.Speed'])
                          y4RangeMax = 1.2*Math.max(...jsonData.countData['VectorCounts.Altitude'])
                      }
                    }
                      
                      setPlotChartLayout({...plotChartLayout,
                          yaxis:{...plotChartLayout.yaxis,
                                   range:[0,yRangeMax]
                          },
                          yaxis2:{...plotChartLayout.yaxis2,
                                      range:[0,y2RangeMax]
                          },
                          yaxis3:{...plotChartLayout.yaxis3,
                            range:[0,y3RangeMax]
                          },
                          yaxis4:{...plotChartLayout.yaxis4,
                            range:[0,y4RangeMax]
                          }, uirevision:1,width:0.98*leftDivWidth})
                    setIsChartLoading(false)
                  })
                  .catch(error => {
                    console.log(error);
                    setIsChartLoading(false)
                  });
        }else{
            setLoadingDataFlag(false)
        }

    },[airport,queryIterTime]) 
    
    function getLatestMetricData(){
      axios.post(backendApiPrefix+'/api/get-vectoring-counts-data/latest/',{airport:airport})
                .then(response => {
                  var jsonData = response.data.message
                  var updateDataObj = {}
                  for(var key of Object.keys(jsonData)){
                        if(Object.hasOwn(vectoringCountsDataAll,key)){
                            updateDataObj[key] = [...vectoringCountsDataAll[key],jsonData[key]]
                        }
                  };
                  setVectoringCountsDataAll(updateDataObj)

                })
                .catch(error => {
                  console.log(error);
                });

    };
    useEffect(() => {
                setPlotMapLayout({...plotMapLayout,
                                    mapbox: {...plotMapLayout.mapbox,
                                                center:{
                                                lat:airportData['location'][0],
                                                lon:airportData['location'][1]
                                                },
                                                bounds:{'north':airportData['location'][0]+200*NM_TO_DEG,
                                                     'east':airportData['location'][1]+200*NM_TO_DEG,
                                                    'south':airportData['location'][0]-200*NM_TO_DEG,
                                                     'west':airportData['location'][1]-200*NM_TO_DEG},
                                    zoom:7}});
        
          var mapTraces = []
          console.log("EE",metroplexData)
          for(var arpt of Object.keys(metroplexData)){
            var trace = {...AIRPORT_MARKER_TEMPLATE,
                          lat:[metroplexData[arpt]['location'][0]],
                          lon:[metroplexData[arpt]['location'][1]],
                          text:[arpt],
                          name:arpt,
                          textfont:{size:14,color:arpt.slice(1)===airport?'black':'gray'},
                          hovertemplate:'<extra></extra>'+arpt
            }
            mapTraces.push(trace)
          }
          setAirportMapTraces(mapTraces)
    },[metroplexData,airportData,airport])
    
    
    // const mounted = useRef();
    // useEffect(() => {
    //    if(mounted.current){
    //        // Component mounted
    //        console.log("Updated")
    //    } else {
    //         console.log("Mounted")
    //         mounted.current = true
            
    //    }
    // });
    // // const chartDiv = useCallback(node => {
    //     // if (node !== null) {
    //       // setLeftDivHeight(node.getBoundingClientRect().height);
    //       // setLeftDivWidth(node.getBoundingClientRect().width);
    //       // console.log("HEIGHT",height)
    //       // console.log("HEIGHT",width)
    //     // }
    //     // }, []);
    // const [isRefreshing, setIsRefreshing] = useState(false);

  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     // This will be called on both refresh and page close
  //     setIsRefreshing(true);
  //     setRevKey(prevVal => prevVal +1)
  //     // The following is necessary for older browsers
  //     event.preventDefault();
  //     event.returnValue = '';
  //   };

    
  //   window.addEventListener('load', handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener('load', handleBeforeUnload);
  //   };
  // });

  // useEffect(() => {
  //   if (isRefreshing) {
  //     // This code will run when the component mounts after a refresh
  //     setPlotMapLayout({...plotMapLayout,
  //                                mapbox: {...plotMapLayout.mapbox,
  //                                            center:{lat:airportData['location'][0],
  //                                                    lon:airportData['location'][1]},
  //                                            bounds:{'north':airportData['location'][0]+200*NM_TO_DEG,
  //                                                     'east':airportData['location'][1]+200*NM_TO_DEG,
  //                                                    'south':airportData['location'][0]-200*NM_TO_DEG,
  //                                                     'west':airportData['location'][1]-200*NM_TO_DEG},
  //                                            accesstoken:"pk.eyJ1IjoidmFydW5zdWRhcnNhbmFuIiwiYSI6ImNscmpiazJ0cDAxb2IyaXFiaWQxY2hobHgifQ.oFJXYhV7inwFB3TeBwa86g",
  //                                            zoom:7,
  //                                }
  //                            });
                             
                                    
  //           setAirportMapTrace({...airportMapTrace,
  //                           lat: [airportData['location'][0]],
  //                           lon: [airportData['location'][1]],
  //                           text:[airport],
  //                           name:airport,
  //                           hovertemplate:'<extra></extra>'+airport,
  //                           })
  //     // Reset the state
  //     setIsRefreshing(false);
  //   }
  // }, [isRefreshing]);
    // useEffect(() => {
        // const handleReload = () => {
           // console.log("RELOAD")   
           
           // setPlotMapLayout({...plotMapLayout,
                                 // mapbox: {...plotMapLayout.mapbox,
                                             // center:{lat:airportData['location'][0],
                                                     // lon:airportData['location'][1]},
                                             // bounds:{'north':airportData['location'][0]+200*NM_TO_DEG,
                                                      // 'east':airportData['location'][1]+200*NM_TO_DEG,
                                                     // 'south':airportData['location'][0]-200*NM_TO_DEG,
                                                      // 'west':airportData['location'][1]-200*NM_TO_DEG},
                                             // accesstoken:"pk.eyJ1IjoidmFydW5zdWRhcnNhbmFuIiwiYSI6ImNscmpiazJ0cDAxb2IyaXFiaWQxY2hobHgifQ.oFJXYhV7inwFB3TeBwa86g",
                                             // zoom:7}
                             // });
                             
                                    
            // setAirportMapTrace({...airportMapTrace,
                            // lat: [airportData['location'][0]],
                            // lon: [airportData['location'][1]],
                            // text:[airport],
                            // name:airport,
                            // hovertemplate:'<extra></extra>'+airport,
                            // })
        // };

        // // Add the event listener for 'beforeunload' to detect window reload
        // window.addEventListener('beforeunload', handleReload);

        // // Cleanup function to remove the event listener when the component is unmounted
        // return () => {
          // window.removeEventListener('beforeunload', handleReload);
        // };
      // });
            
    useEffect(() => {
        const resizeObserver = new ResizeObserver((event) => {
            // Depending on the layout, you may need to swap inlineSize with blockSize
            // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentBoxSize
            setLeftDivWidth(event[0].contentBoxSize[0].inlineSize);
            setLeftDivHeight(event[0].contentBoxSize[0].inlineSize);
        });

        resizeObserver.observe(document.getElementById("plotlyChartDiv"));
        
        
    });
    
    useEffect(() => {
        const resizeObserver = new ResizeObserver((event) => {
            // Depending on the layout, you may need to swap inlineSize with blockSize
            // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentBoxSize
            setRightDivWidth(event[0].contentBoxSize[0].inlineSize);
            setRightDivHeight(event[0].contentBoxSize[0].inlineSize);
        });

        resizeObserver.observe(document.getElementById("plotlyMapDiv"));
    });
    const [menuOption, setMenuOption] = useState(1);
    const [acMenuOption, setAcMenuOption] = useState(1);
    const [heatMapDisplayFlag,setHeatMapDisplayFlag] = useState(true);

    const setYRanges=()=>{
      var updateYLabel = {yaxis:{...plotChartLayout.yaxis,
        range:[0,1.2*Math.max(...vectoringCountsDataAll.NumArrAC)]},
      yaxis2:{...plotChartLayout.yaxis2,
        range:[0,!normalizationFlag?1.2*Math.max(...vectoringCountsDataAll.NormalizedVectorCounts.Heading):1.2*Math.max(...vectoringCountsDataAll.VectorCounts.Heading)]},
      yaxis3:{...plotChartLayout.yaxis3,
        range:[0,!normalizationFlag?1.2*Math.max(...vectoringCountsDataAll.NormalizedVectorCounts.Speed):1.2*Math.max(...vectoringCountsDataAll.VectorCounts.Speed)]},
      yaxis4:{...plotChartLayout.yaxis4,
        range:[0,!normalizationFlag?1.2*Math.max(...vectoringCountsDataAll.NormalizedVectorCounts.Altitude):1.2*Math.max(...vectoringCountsDataAll.VectorCounts.Altitude)]}}
    setPlotChartLayout({...plotChartLayout,...updateYLabel})
    };
    const handleMenuSelection = (event: SelectChangeEvent) => {
        if(event.target.value===1){
          setHeatMapDisplayFlag(true)
        }else{
          setHeatMapDisplayFlag(false)
        }
        setMenuOption(String(event.target.value));
        setYRanges()
      };
    
    const handleAcSelection = (event: SelectChangeEvent) => {
        console.log(event.target.value)
        console.log(anomalousAcList)
        console.log(anomalousAcList[event.target.value-1])
        setSelectedAc(anomalousAcList[event.target.value-1])
        setAcMenuOption(String(event.target.value));
        setYRanges()
      };

    const handleDoubleClickOnMap=(data)=>{
      setTimeout(()=>{
        setPlotMapLayout({...plotMapLayout,
            mapbox: {...plotMapLayout.mapbox,
                        center:{
                        lat:airportData['location'][0],
                        lon:airportData['location'][1]
                        },
                        bounds:{'north':airportData['location'][0]+200*NM_TO_DEG,
                             'east':airportData['location'][1]+200*NM_TO_DEG,
                            'south':airportData['location'][0]-200*NM_TO_DEG,
                             'west':airportData['location'][1]-200*NM_TO_DEG},
            zoom:7}})},20);
    }
        
    const handleLatestEpochButton=()=>{
      setLatestEpochFlag(true)
      setSelectedEpoch(vectoringCountsDataAll.Epoch[vectoringCountsDataAll.Epoch.length-1])
      setYRanges()
    }

    const handleHeatMapMetricCheckbox=(e,metric)=>{
      setHeatMapMetricChecked({
        ...heatMapMetricChecked,
        [metric]:!heatMapMetricChecked[metric]
      })
      setYRanges()
    }

    useEffect(()=>{
      var tracesList = []
      var idx = 0
      var metKey
      var markerColor;
      if(heatMapDisplayFlag){
        for(metKey of Object.keys(heatMapMetricChecked)){
          markerColor = colorPalette[idx]
          if(heatMapMetricChecked[metKey]){
            let cScaleArray = new Array(heatMapData[metKey][heatMapTimePeriod]['lat'].length)
            cScaleArray.fill(10)
            console.log(heatMapData[metKey][heatMapTimePeriod]['lon'])
            console.log(heatMapData[metKey][heatMapTimePeriod]['lat'])
            if(!onlyClustersFlag){
            tracesList.push({type: "scattermapbox", lon:heatMapData[metKey][heatMapTimePeriod]['lon'], 
                                                    lat:heatMapData[metKey][heatMapTimePeriod]['lat'],
                                                    text:heatMapData[metKey][heatMapTimePeriod]['alt'],
                            name:heatMapMetricLabel[metKey],
                            marker: {color: markerColor, size: 5 },
                            hovertemplate:'<extra></extra>'+heatMapMetricLabel[metKey]+'<br>Lat:%{lat}, Lon:%{lon}, Alt:%{text}ft',
                            radius: 50})
            }
            if(displayClustersFlag){
              tracesList.push({type: "scattermapbox", lon:heatMapClustersData[metKey][heatMapTimePeriod]['lon'], 
                lat:heatMapClustersData[metKey][heatMapTimePeriod]['lat'],
                text:heatMapClustersData[metKey][heatMapTimePeriod]['alt'],
                name:heatMapMetricLabel[metKey]+'_cluster',
                marker: {color: markerColor, size: 12 },
                hovertemplate:'<extra></extra>'+heatMapMetricLabel[metKey]+'<br>Lat:%{lat}, Lon:%{lon}, Alt:%{text}ft',
                radius: 50})
              }
          }
          idx += 1
        };
      }else{
        var additionalData = [];
        for(metKey of Object.keys(anomalousAircraftMetricChecked)){
          markerColor = colorPalette[idx]
          if(anomalousAircraftMetricChecked[metKey]){
            // let cScaleArray = new Array(heatMapData[metKey][heatMapTimePeriod]['lat'].length)
            // cScaleArray.fill(10)            
            // if(Object.keys(vectoringAircraftData[metKey]).includes(selectedAc)){
            for(var ac of Object.keys(vectoringAircraftData[metKey])){
              for(var trIdx in vectoringAircraftData[metKey][ac]['speed']){
                additionalData.push([vectoringAircraftData[metKey][ac]['speed'][trIdx],vectoringAircraftData[metKey][ac]['heading'][trIdx],
                                vectoringAircraftData[metKey][ac]['altitudePhase'][trIdx],vectoringAircraftData[metKey][ac]['speedPhase'][trIdx],
                                vectoringAircraftData[metKey][ac]['headingPhase'][trIdx],vectoringAircraftData[metKey][ac]['positionTime'][trIdx]])
              }
              tracesList.push({type: "scattermapbox", lon:vectoringAircraftData[metKey][ac]['longitude'], 
                lat:vectoringAircraftData[metKey][ac]['latitude'], 
                text:vectoringAircraftData[metKey][ac]['altitude'], 
                customdata:additionalData,
                name:metKey+', '+ac,
                mode:'lines+markers',
                marker: {color: markerColor, size: 5 },
                hovertemplate:'<extra></extra>'+ac+'<br>Lat:%{lat}, Lon:%{lon}'+
                              '<br>Alt:%{text}ft (%{customdata[2]})'+
                              '<br>Speed:%{customdata[0]} kts (%{customdata[3]})'+
                              '<br>Heading:%{customdata[1]}\u00B0 (%{customdata[4]})'+
                              '<br>%{customdata[5]}',
                radius: 50})
            }
          }
          idx += 1
        };
      }
      setMapPlotTraces(tracesList)
      
    },[heatMapDisplayFlag,heatMapData,selectedAc,heatMapClustersData,heatMapMetricChecked,heatMapTimePeriod,onlyClustersFlag,displayClustersFlag,anomalousAircraftMetricChecked])
    
    useEffect(()=>{
      if(selectedEpoch!==''){
        updateAnomalousAircraftData(selectedEpoch)
      }
        
    },[anomalousAircraftMetricChecked])
    
    const handleClickOnChart=(data)=>{
      console.log(data)
      setLatestEpochFlag(false)
      var point = data.points[0]
      
      if(!(new Date(point.x) instanceof Date && !isNaN(new Date(point.x).valueOf()))){
          return;
      }
      console.log(point)
      console.log(point.pointIndex)
      
      setSelectedEpoch(vectoringCountsDataAll.Epoch[point.pointIndex])
      updateHeatMapData(vectoringCountsDataAll.Epoch[point.pointIndex])
      updateAnomalousAircraftData(vectoringCountsDataAll.Epoch[point.pointIndex])
      setYRanges()
      // var updateYLabel = {yaxis:{...plotChartLayout.yaxis,range:[0,1.2*Math.max(...vectoringCountsDataAll.NumArrAC)]},
      //                     yaxis2:{...plotChartLayout.yaxis2,
      //                             range:[0,!normalizationFlag?1.2*Math.max(...vectoringCountsDataAll.NormalizedVectorCounts.Heading):1.2*Math.max(...vectoringCountsDataAll.VectorCounts.Heading)]},
      //                     yaxis3:{...plotChartLayout.yaxis3,
      //                             range:[0,!normalizationFlag?1.2*Math.max(...vectoringCountsDataAll.NormalizedVectorCounts.Speed):1.2*Math.max(...vectoringCountsDataAll.VectorCounts.Speed)]},
      //                     yaxis4:{...plotChartLayout.yaxis4,
      //                             range:[0,!normalizationFlag?1.2*Math.max(...vectoringCountsDataAll.NormalizedVectorCounts.Altitude):1.2*Math.max(...vectoringCountsDataAll.VectorCounts.Altitude)]}}
      // setPlotChartLayout({...plotChartLayout,...updateYLabel})
  };
  useEffect(()=>{
    var updateYHighlightMarker = {}
    var normalizedPrefix = normalizationFlag?'Normalized':''
    for(var axNum of ['','2','3','4']){
      if(axNum===''){
        updateYHighlightMarker['index'+axNum] = 1.2*Math.max(...vectoringCountsDataAll.NumArrAC)
      }else if(axNum ==='2'){
        updateYHighlightMarker['index'+axNum] = 1.2*Math.max(...vectoringCountsDataAll[normalizedPrefix+'VectorCounts'].Heading)
      }else if(axNum ==='3'){
        updateYHighlightMarker['index'+axNum] = 1.2*Math.max(...vectoringCountsDataAll[normalizedPrefix+'VectorCounts'].Speed)
      }else if(axNum ==='4'){
        updateYHighlightMarker['index'+axNum] = 1.2*Math.max(...vectoringCountsDataAll[normalizedPrefix+'VectorCounts'].Altitude)
      }
    }
    setHighlightYMarker(updateYHighlightMarker)
  },[plotChartLayout,vectoringCountsDataAll,normalizationFlag])
  
  var highlightMarkerTraces = []
  for(var axNum of ['','2','3','4']){
    highlightMarkerTraces.push({ x:[selectedEpoch,selectedEpoch],
      y:[0,highlightYMarker['index'+axNum]],
      type:'scatter',
      xaxis:'x',yaxis:'y'+axNum,
      mode:'lines',
      showlegend:false,
      hoverinfo:'skip',
      hovertemplate:'<extra></extra>',
      line:{color:'black',dash:'dashdot'}})
  };


  const handleTimePeriodChange=(event,newValue)=>{
    if(newValue){
      setHeatMapTimePeriod(newValue)
    }
    
    // setYRanges()
  };
  const handleAnomalyTypesCheckbox=(e,metric)=>{
    setAnomalousAircraftMetricChecked({
      ...anomalousAircraftMetricChecked,
      [metric]:!anomalousAircraftMetricChecked[metric]
    })
    setYRanges()
  };
  const handleClusterDisplay=(e)=>{
    setDisplayClustersFlag(displayClustersFlag=>!displayClustersFlag)
  }
  const handleOnlyClusterDisplay=(e)=>{
    setOnlyClustersFlag(onlyClustersFlag=>!onlyClustersFlag)
    if(!onlyClustersFlag){
      setDisplayClustersFlag(true)
    }
    
  }
    const handleNormalization=(e)=>{
      var yTitles = {}
      for(var axNum of ['2','3','4']){
        var currentTitle = plotChartLayout['yaxis'+axNum].title.text
        var newTitle;
        if(!normalizationFlag){
          newTitle = currentTitle.split('<br>')[0]+'<br>Counts per Arr. AC'
        }else{
          newTitle = currentTitle.split('<br>')[0]+'<br>Counts'
        }  
        yTitles['yaxis'+axNum] = newTitle
      }
      var updateYLabel = {yaxis:{...plotChartLayout.yaxis,
                        range:[0,1.2*Math.max(...vectoringCountsDataAll.NumArrAC)]},
                      yaxis2:{...plotChartLayout.yaxis2,
                        range:[0,!normalizationFlag?1.2*Math.max(...vectoringCountsDataAll.NormalizedVectorCounts.Heading):1.2*Math.max(...vectoringCountsDataAll.VectorCounts.Heading)],
                        title:{text:yTitles['yaxis2']}},
                      yaxis3:{...plotChartLayout.yaxis3,
                        range:[0,!normalizationFlag?1.2*Math.max(...vectoringCountsDataAll.NormalizedVectorCounts.Speed):1.2*Math.max(...vectoringCountsDataAll.VectorCounts.Speed)],
                        title:{text:yTitles['yaxis3']}},
                      yaxis4:{...plotChartLayout.yaxis4,
                        range:[0,!normalizationFlag?1.2*Math.max(...vectoringCountsDataAll.NormalizedVectorCounts.Altitude):1.2*Math.max(...vectoringCountsDataAll.VectorCounts.Altitude)],
                        title:{text:yTitles['yaxis4']}}}
      setPlotChartLayout({...plotChartLayout,...updateYLabel})
      setNormalizationFlag(!normalizationFlag)
      
    }
    return (
        <Layout>
        <PlotSectionDiv id="chartPlotDiv" flexRatio={1}>
            <PlotLoadingOverlay show={isChartLoading}/>
            <div style={{width:'200px',zIndex:5,position:'absolute',marginTop:'20px',marginLeft:'255px',display:'fixed',color:loadingDataFlag?'gray':'black'}}>
                <FormControlLabel
                label={<Typography sx={{marginLeft:-0.8,fontSize:14}}>Normalize</Typography>}
                control={<Checkbox  checked={normalizationFlag} 
                           disabled={loadingDataFlag}
                           size="small"
                           onChange={(e)=>{handleNormalization(e)}
                                    }
                />}
                />
            </div>
            <EpochDataBlock selectedEpoch={selectedEpoch} handleLatestEpochButton={handleLatestEpochButton}
                            lastUpdatedTime={lastUpdatedTime}/>
            <Plot  data={[{
                    x: vectoringCountsDataAll.Epoch,
                    y: vectoringCountsDataAll.NumArrAC,
                    type: 'scatter',
                    mode: 'lines',
                    marker: {color: 'rgba(255,0,0,0.4)'},
                    name:'NumArrAC',
                    hovertemplate:'%{y}<extra>NumArrAC</extra>',
                    xaxis:'x',
                    yaxis:'y',
                  },{
                    x: vectoringCountsDataAll.Epoch,
                    y: normalizationFlag?vectoringCountsDataAll.NormalizedVectorCounts.Heading:vectoringCountsDataAll.VectorCounts.Heading,
                    type: 'scatter',
                    mode: 'lines',
                    marker: {color: 'rgba(255,0,0,0.4)'},
                    name:'Heading Changes',
                    hovertemplate:'%{y}<extra>Heading Change Counts</extra>',
                    xaxis:'x',
                    yaxis:'y2',
                  },
                  {
                    x: vectoringCountsDataAll.Epoch,
                    y: normalizationFlag?vectoringCountsDataAll.NormalizedVectorCounts.Speed:vectoringCountsDataAll.VectorCounts.Speed,
                    type: 'scatter',
                    mode: 'lines',
                    marker: {color: 'rgba(255,0,0,0.4)'},
                    name:'Speed Changes',
                    hovertemplate:'%{y}<extra>Speed Change Counts</extra>',
                    xaxis:'x',
                    yaxis:'y3',
                  },
                  {
                    x: vectoringCountsDataAll.Epoch,
                    y: normalizationFlag?vectoringCountsDataAll.NormalizedVectorCounts.Altitude:vectoringCountsDataAll.VectorCounts.Altitude,
                    type: 'scatter',
                    mode: 'lines',
                    marker: {color: 'rgba(255,0,0,0.4)'},
                    name:'Altitude Changes',
                    hovertemplate:'%{y}<extra>Altitude Change Counts</extra>',
                    xaxis:'x',
                    yaxis:'y4',
                  },
                  ...highlightMarkerTraces   
                ]}
                layout= {plotChartLayout}
                config= {plotConfig}
                divId={'plotlyChartDiv'}
                onClick={handleClickOnChart}
                style={{minWidth:'300px',height:'95%',position:'relative'}}
                useResizeHandler={true}
              />
        </PlotSectionDiv>
        <PlotSectionDiv id="mapPlotDiv" key={revKey} flexRatio={1}>
            <PlotLoadingOverlay show={isMapLoading} label="Loading map…"/>
            <Box sx={{mb:1,mt:2,ml:2,mr:3}}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label"></InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={menuOption}
                  label=""
                  onChange={handleMenuSelection}
                  sx={{height:30}}
                >
                  <MenuItem value={1}>Vectoring Locations</MenuItem>
                  <MenuItem value={2}>Anomalous Aircraft</MenuItem>
                </Select>
              </FormControl>
              {heatMapDisplayFlag&&
              <>
              <Box sx={{mb:-1,mt:1,ml:0,mr:0}}>
              <ToggleButtonGroup fullWidth
                  color="primary"
                  value={heatMapTimePeriod}
                  exclusive
                  onChange={handleTimePeriodChange}
                  aria-label="Platform"
                  sx={{height:30}}
                >
                  <ToggleButton value="5min">5 Minutes</ToggleButton>
                  <ToggleButton value="1hr">1 Hour</ToggleButton>
                  <ToggleButton value="24hr">24 Hours</ToggleButton>
              </ToggleButtonGroup>
              </Box>
              <Box sx={{mb:-1,mt:1,ml:0,mr:3,display:'flex',justifyContent:'flex-start'}}>
              {heatMapMetrics.map((metric)=>{
                      return( <div style={{width:'200px',color:'#275AA6'}}>
                                  <Checkbox  checked={heatMapMetricChecked[metric]} 
                                             onChange={(e)=>{handleHeatMapMetricCheckbox(e,metric)}
                                                      }
                                  />
                                  {heatMapMetricLabel[metric]}
                              </div>)})}
              </Box>
              <Box sx={{mb:-1,mt:1,ml:0,mr:3,display:'flex',justifyContent:'flex-start'}}>
                <div style={{width:'500px',color:'#275AA6'}}>
                          <Checkbox  checked={displayClustersFlag} 
                                     onChange={(e)=>{handleClusterDisplay(e)}}/>
                          Show clusters 
                          <Checkbox  checked={onlyClustersFlag} 
                                     onChange={(e)=>{handleOnlyClusterDisplay(e)}}/>
                          Only clusters 
                </div>
              </Box>
              </>
              }
              {!heatMapDisplayFlag&&
              <>
              <Box sx={{mb:-1,mt:1,ml:0,mr:3,display:'flex',justifyContent:'flex-start'}}>
                {heatMapMetrics.map((metric)=>{
                        return( <div style={{width:'200px',color:'#275AA6'}}>
                                    <Checkbox  checked={anomalousAircraftMetricChecked[metric]} 
                                              onChange={(e)=>{handleAnomalyTypesCheckbox(e,metric)}
                                                        }
                                    />
                                    {heatMapMetricLabel[metric]}
                                </div>)}) }
              </Box>
              <Box sx={{mt:2,mb:-1}}>
                {false&&<FormControl>
                <InputLabel id="demo-simple-select-label"></InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={acMenuOption}
                  label=""
                  onChange={handleAcSelection}
                  sx={{height:30}}
                >
                  {anomalousAcList.map((acid,index)=>{
                    return( <MenuItem value={index+1}>{acid}</MenuItem>)
                  })}
                </Select>
              </FormControl>}
              </Box>
              </>
              }
            </Box>
            <Plot data={[...airportMapTraces,...mapPlotTraces]}
                  layout= {plotMapLayout}
                  config= {{...plotConfig,scrollZoom:true}}
                  useResizeHandler={true}
                  onDoubleClick={handleDoubleClickOnMap}
                  divId={'plotlyMapDiv'}
                  style={{minWidth:'300px',height:'90%',position:'relative',borderWidth:'2px',color:'yellow',
                            borderSyle:'solid',
                            borderColor:'black'}}
            />
        </PlotSectionDiv>  
        </Layout>
    );
};

export default VectoringCounts